import React, { forwardRef } from 'react';
import './ReportsPrint.scss';

const ReportsPrint = forwardRef((props, ref) => {
  const { data, totals, counts, formatCurrency, getStatusColor } = props;

  // Calcula ticket médio
  const ticketMedio = {
    mo_lataria: counts.qtd_os_funilaria > 0
      ? totals.mo_lataria / counts.qtd_os_funilaria
      : 0,
    qtd_horas_lataria: totals.qtd_horas_lataria > 0
      ? totals.mo_lataria / totals.qtd_horas_lataria
      : 0,
    qtd_pecas_pintadas: totals.qtd_pecas_pintadas > 0
      ? totals.mo_lataria / totals.qtd_pecas_pintadas
      : 0,
    mo_estetica: counts.qtd_os_servicos > 0
      ? totals.mo_estetica / counts.qtd_os_servicos
      : 0,
    qtd_horas_estetica: totals.qtd_horas_estetica > 0
      ? totals.mo_estetica / totals.qtd_horas_estetica
      : 0,
    valor_pecas: counts.qtd_os_pecas > 0
      ? totals.valor_pecas / counts.qtd_os_pecas
      : 0,
    total_os: counts.qtd_os_total > 0
      ? totals.total_os / counts.qtd_os_total
      : 0,
  };

  // Calcula percentual sobre receita
  const percentualReceita = {
    qtd_horas_lataria: totals.total_os > 0
      ? (totals.mo_lataria / totals.total_os) * 100
      : 0,
    mo_estetica: totals.total_os > 0
      ? (totals.mo_estetica / totals.total_os) * 100
      : 0,
    valor_pecas: totals.total_os > 0
      ? (totals.valor_pecas / totals.total_os) * 100
      : 0,
  };

  return (
    <div ref={ref} className="reports-print">
      <div className="reports-print-header">
        <h1>Relatório de Ordens de Serviço</h1>
        <p className="reports-print-date">
          Gerado em: {new Date().toLocaleDateString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          })}
        </p>
      </div>

      <div className="reports-print-table">
        <div className="reports-print-table-header">
          <div className="header-cell">Código</div>
          <div className="header-cell">Veículo</div>
          <div className="header-cell">MO Funilaria</div>
          <div className="header-cell">Hrs Funilaria</div>
          <div className="header-cell">Peças Pintadas</div>
          <div className="header-cell">MO Estética</div>
          <div className="header-cell">Hrs Estética</div>
          <div className="header-cell">Valor Peças</div>
          <div className="header-cell">Custo Peças</div>
          <div className="header-cell">Lucro Peças</div>
          <div className="header-cell">Total OS</div>
          <div className="header-cell">Status</div>
          <div className="header-cell">Previsão</div>
        </div>

        <div className="reports-print-table-body">
          {data.map((item, index) => (
            <div
              key={item.id}
              className={`table-row ${index % 2 === 0 ? 'row-even' : 'row-odd'}`}
            >
              <div className="table-cell">{item.code}</div>
              <div className="table-cell table-cell-vehicle">{item.vehicle}</div>
              <div className="table-cell table-cell-right">
                {formatCurrency(item.mo_lataria)}
              </div>
              <div className="table-cell table-cell-right">
                {item.qtd_horas_lataria.toFixed(2)}
              </div>
              <div className="table-cell table-cell-right">
                {item.qtd_pecas_pintadas.toFixed(0)}
              </div>
              <div className="table-cell table-cell-right">
                {formatCurrency(item.mo_estetica)}
              </div>
              <div className="table-cell table-cell-right">
                {item.qtd_horas_estetica.toFixed(2)}
              </div>
              <div className="table-cell table-cell-right">
                {formatCurrency(item.valor_pecas)}
              </div>
              <div className="table-cell table-cell-right">
                {formatCurrency(item.custo_pecas)}
              </div>
              <div className="table-cell table-cell-right table-cell-lucro">
                {formatCurrency(item.lucro_pecas)}
              </div>
              <div className="table-cell table-cell-right table-cell-total">
                {formatCurrency(item.total_os)}
              </div>
              <div className="table-cell">
                <div
                  className="status-badge"
                  style={{
                    backgroundColor: getStatusColor(item.status),
                  }}
                >
                  {item.status}
                </div>
              </div>
              <div className="table-cell">{item.previsao_entrega}</div>
            </div>
          ))}
        </div>

        <div className="reports-print-table-footer">
          <div className="footer-row footer-row-totals">
            <div className="footer-cell footer-cell-label">TOTAIS</div>
            <div className="footer-cell"></div>
            <div className="footer-cell footer-cell-right">
              {formatCurrency(totals.mo_lataria)}
            </div>
            <div className="footer-cell footer-cell-right">
              {totals.qtd_horas_lataria.toFixed(2)}
            </div>
            <div className="footer-cell footer-cell-right">
              {totals.qtd_pecas_pintadas.toFixed(0)}
            </div>
            <div className="footer-cell footer-cell-right">
              {formatCurrency(totals.mo_estetica)}
            </div>
            <div className="footer-cell footer-cell-right">
              {totals.qtd_horas_estetica.toFixed(2)}
            </div>
            <div className="footer-cell footer-cell-right">
              {formatCurrency(totals.valor_pecas)}
            </div>
            <div className="footer-cell footer-cell-right">
              {formatCurrency(totals.custo_pecas)}
            </div>
            <div className="footer-cell footer-cell-right">
              {formatCurrency(totals.lucro_pecas)}
            </div>
            <div className="footer-cell footer-cell-right footer-cell-total">
              {formatCurrency(totals.total_os)}
            </div>
            <div className="footer-cell"></div>
            <div className="footer-cell"></div>
          </div>

          <div className="footer-row footer-row-counts">
            <div className="footer-cell footer-cell-label">QTD ORDENS DE SERVIÇOS</div>
            <div className="footer-cell"></div>
            <div className="footer-cell footer-cell-center">{counts.qtd_os_funilaria}</div>
            <div className="footer-cell"></div>
            <div className="footer-cell"></div>
            <div className="footer-cell footer-cell-center">{counts.qtd_os_servicos}</div>
            <div className="footer-cell"></div>
            <div className="footer-cell footer-cell-center">{counts.qtd_os_pecas}</div>
            <div className="footer-cell"></div>
            <div className="footer-cell"></div>
            <div className="footer-cell footer-cell-center footer-cell-highlight">{counts.qtd_os_total}</div>
            <div className="footer-cell"></div>
            <div className="footer-cell"></div>
          </div>

          <div className="footer-row footer-row-counts">
            <div className="footer-cell footer-cell-label">TICKET MÉDIO</div>
            <div className="footer-cell"></div>
            <div className="footer-cell footer-cell-right">
              {formatCurrency(ticketMedio.mo_lataria)}
            </div>
            <div className="footer-cell footer-cell-right">
              {formatCurrency(ticketMedio.qtd_horas_lataria)}
            </div>
            <div className="footer-cell footer-cell-right">
              {formatCurrency(ticketMedio.qtd_pecas_pintadas)}
            </div>
            <div className="footer-cell footer-cell-right">
              {formatCurrency(ticketMedio.mo_estetica)}
            </div>
            <div className="footer-cell footer-cell-right">
              {formatCurrency(ticketMedio.qtd_horas_estetica)}
            </div>
            <div className="footer-cell footer-cell-right">
              {formatCurrency(ticketMedio.valor_pecas)}
            </div>
            <div className="footer-cell"></div>
            <div className="footer-cell"></div>
            <div className="footer-cell footer-cell-right footer-cell-highlight">
              {formatCurrency(ticketMedio.total_os)}
            </div>
            <div className="footer-cell"></div>
            <div className="footer-cell"></div>
          </div>

          <div className="footer-row footer-row-counts">
            <div className="footer-cell footer-cell-label">PERCENTUAL SOBRE RECEITA</div>
            <div className="footer-cell"></div>
            <div className="footer-cell"></div>
            <div className="footer-cell footer-cell-right">
              {percentualReceita.qtd_horas_lataria.toFixed(2)}%
            </div>
            <div className="footer-cell"></div>
            <div className="footer-cell footer-cell-right">
              {percentualReceita.mo_estetica.toFixed(2)}%
            </div>
            <div className="footer-cell"></div>
            <div className="footer-cell footer-cell-right">
              {percentualReceita.valor_pecas.toFixed(2)}%
            </div>
            <div className="footer-cell"></div>
            <div className="footer-cell"></div>
            <div className="footer-cell"></div>
            <div className="footer-cell"></div>
            <div className="footer-cell"></div>
          </div>
        </div>
      </div>
    </div>
  );
});

ReportsPrint.displayName = 'ReportsPrint';

export default ReportsPrint;
